import { render } from "./BlogFooter.vue?vue&type=template&id=dac3081a&scoped=true"
import script from "./BlogFooter.vue?vue&type=script&lang=js"
export * from "./BlogFooter.vue?vue&type=script&lang=js"

import "./BlogFooter.vue?vue&type=style&index=0&id=dac3081a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dac3081a"]])

export default __exports__